import dynamic from "next/dynamic";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SiteContext } from "../../Contexts/SiteContext";
import { _oldSelectImageForDevice } from "../../../utils";
import { useCallback } from "react";
import { hasProperty } from "../../../utils/validate";

import CountdownTimer from "../Quest/CountdownTimer";

import BannerButtons from "./molecules/BannerButtons";

// This is the default banner
const LazyLoad = dynamic(import("../Image/LazyLoad"));
let handleScrollPosFrom = 0;
let handleScrollPosTo = 0;

const Timer = ({ timerData }) => {
	return <div className={"countdownTimerHolder alignCenter"}>
		<CountdownTimer data={timerData} />
	</div>
};

const ProductBanner = (props) => {
	const {
		pageData,
		category,
		slug,
		setOpenBATD,
		getFormData,
		hasArrow = true,
		refElement,
		banner,
	} = props;

	const animateScroll = useCallback(() => {
		handleScrollPosFrom = handleScrollPosFrom + 25;

		if (handleScrollPosFrom < handleScrollPosTo) {
			window.scrollTo(0, handleScrollPosFrom);
			requestAnimationFrame(animateScroll);
		} else if (handleScrollPosFrom >= handleScrollPosTo) {
			window.scrollTo(0, handleScrollPosTo);
		}
	}, [handleScrollPosFrom, handleScrollPosTo]);

	const goDown = useCallback(() => {
		var banner = document.getElementsByClassName("banner")[0];
		if (banner) {
			handleScrollPosFrom = window.pageYOffset;
			handleScrollPosTo = banner.offsetHeight;
			requestAnimationFrame(animateScroll);
		}
	}, [handleScrollPosFrom, handleScrollPosTo]);

	const hasButtons = hasProperty(props.banner, "buttons") && props.banner.buttons != null;
	const hasImage = hasProperty(props.banner, "image") && props.banner.image !== null;
	const hasOsm = props.banner.image && props.banner.image.overseasModelShown;

	return (
		<SiteContext.Consumer>
			{({ deviceType }) => (
				<div ref={refElement} className="banner">
					{hasImage ? (
						<div className="imageHolder">
							{props.banner.countdownTimer && props.banner.countdownTimer !== null &&
								<Timer timerData={props.banner.countdownTimer} />}

							<div className="overlay">
								{hasOsm && (
									<h6 className="disc">*Overseas model shown</h6>
								)}
							</div>

							{props.banner.image.kind === "image" &&
								<LazyLoad
									image={_oldSelectImageForDevice(
										deviceType,
										props.banner
									)}
									alt={props.banner.title}
									title={props.banner.title}
								/>

							}

							{/* // TODO: Create a better format of how the banner video should low */}
							{props.banner.image.kind === "video" &&
								<video
									width={`100%`} height={`100%`}
									key={deviceType == 'mobile' || deviceType == 'tablet' ? props.banner.mobile.url ? props.banner.mobile.url : props.banner.image.url : props.banner.image.url}
									controls={props.banner.videoSettings.enableControls}
									autoPlay={props.banner.videoSettings.autoplay}
									muted={props.banner.videoSettings.muted}
									loop={props.banner.videoSettings.loop}
									fullscreen={fullscreen.toString()}
								>
									<source src={deviceType == 'mobile' || deviceType == 'tablet' ? props.banner.mobile.url ? props.banner.mobile.url : props.banner.image.url : props.banner.image.url} type="video/mp4"></source>
								</video>
							}

						</div>) : null
					}
					<div data-target={deviceType} className="productBannerCopyHolder productBanner">
						<div className="productBannerCopy">
							{props.banner.title !== null &&
								<div className="copy">
									{props.banner.title != null &&
										<>
											<div className="line" />
											<h1>{props.banner.title}</h1>
										</>
									}
									{props.banner.description != null &&
										<h6>
											{parse(props.banner.description)}
										</h6>
									}
								</div>
							}
							<BannerButtons
								pageData={pageData}
								hasButtons={hasButtons}
								banner={banner}
								category={category}
								slug={slug}
								getFormData={getFormData}
								setOpenBATD={setOpenBATD}
							/>
						</div>
					</div>
					{hasArrow && (
						<div className="arrow" onClick={goDown}>
							<FontAwesomeIcon
								icon={["fal", "angle-down"]}
								size="2x"
							/>
						</div>
					)}
				</div>
			)}
		</SiteContext.Consumer>
	);
};

export default ProductBanner;
